<template>
  <div>
    <el-tabs style="position: sticky;top:0;z-index: 2;background-color: #212731" v-model="activeTab">
      <!--  -----------------------------详单------------------------------ -->
      <el-tab-pane name="tab1">
        <span slot="label" style="margin-left: 10px;"><i class="el-icon-notebook-2"></i>&nbsp;&nbsp;详单</span>
        <div>

          <div style="background-color: #222933;padding: 20px;">
            <div style="font-size: x-large;">{{agentName}}</div>
            <el-divider/>
            <div style="margin-right: 10px;text-align: right;font-size: larger;">
            <span>
              <i class="el-icon-money"/>
              现金余额:￥{{agentMoneySum}}
            </span>
            <span style="margin-left: 30px;">
              <i class="el-icon-bank-card"/>
              代金券余额:￥
              {{agentVouchersSum}}
            </span>
            </div>
          </div>

          <el-table stripe :data="moneyDetails" v-if="moneyDetails.length>0">
            <el-table-column prop="index"        label=""  width="64">
              <template slot-scope="scope">
                <el-avatar :size="32" shape="square">{{scope.row.index}}</el-avatar>
              </template>
            </el-table-column>
            <el-table-column prop="date"        label="时间"  width="150"/>
            <el-table-column prop="moneyType"   label="币种"  width="80"/>
            <el-table-column prop="delta"       label="金额"  width="80"/>
            <el-table-column prop="sum"         label="余额"  width="80"/>
            <el-table-column prop="purpose"     label="事由"/>
            <el-table-column prop="description" label="详情"/>
            <el-table-column label="操作" width="320" align="right">
              <template slot="header" slot-scope="scope">
                <el-button type="primary" icon="el-icon-refresh" circle @click="reloadDetails"></el-button>
              </template>
              <template slot-scope="scope">
                <el-button size="small" icon="el-icon-collection-tag" circle></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else>
            <span style="margin-left: 40px;font-size: large;">
              <i class="el-icon-phone"></i>
              获取财务详单，请联系精诊客服专员
            </span>
          </div>
        </div>
      </el-tab-pane>
      <!--  -----------------------------管理------------------------------ -->
      <el-tab-pane name="tab2">
        <span slot="label" style="margin-left: 10px;"><i class="el-icon-s-tools"></i>&nbsp;&nbsp;设置</span>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex';
import {isAdmin, isDoc, isAgent} from '@/utils';
import {task as taskApi} from '@/api';

export default {
  name: 'AgentMoneyDetail',
  data() {
    return {
      activeTab: 'tab1',
      agentName: '',
      agentVouchersSum: 0,
      agentMoneySum: 0,
      moneyDetails: []
    };
  },
  components: {
  },
  computed: {
    ...mapState('common', ['userInfo']),
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    }
  },
  async mounted() {
    this.onCreated();
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  },
  methods: {
    async onCreated() {
      this.reloadDetails();
    },
    reloadDetails() {
      taskApi.agentDetail({}).then(res => {
        if (res.code === 10000) {
          this.agentName = res.data.agentName;
          this.agentMoneySum = res.data.moneySum;
          this.agentVouchersSum = res.data.vouchersSum;
        }
      });
      /*
      taskApi.agentMoneyDetails({}).then(res => {
        this.moneyDetails.length = 0;
        if (res.code === 10000) {
          let tableData = res.data.map((r, index) => {
            const dateObj = new Date(r.createTime);
            let moneyType = Math.abs(r.moneyDelta) > 0 ? 1 : 0;
            let delta = moneyType > 0 ? r.moneyDelta : r.vouchersDelta;
            delta = (delta > 0 ? '+' : '') + delta.toFixed(2);
            let sum = (moneyType > 0 ? r.moneySum : r.vouchersSum).toFixed(2);
            return {
              index: res.data.length - index,
              date: dateObj.toLocaleDateString() + ' ' + dateObj.toLocaleTimeString(),
              moneyType: moneyType > 0 ? '现金' : '代金',
              delta,
              sum,
              purpose: r.purpose,
              description: r.description
            };
          });
          for (let d of tableData) {
            this.moneyDetails.push(d);
          }
        }
      });
      */
    }
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/view/AgentMoneyDetail/index.vue